import { render, staticRenderFns } from "./dr-tabs.vue?vue&type=template&id=791a732d&scoped=true&"
import script from "./dr-tabs.vue?vue&type=script&lang=js&"
export * from "./dr-tabs.vue?vue&type=script&lang=js&"
import style0 from "./dr-tabs.vue?vue&type=style&index=0&id=791a732d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a732d",
  null
  
)

export default component.exports